"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDelayedConditionEvaluator = void 0;
const react_1 = require("react");
/**
 * Delayed Visibility condition ===> show the CTA after a few milliseconds.
 */
function useDelayedConditionEvaluator(visibilityCondition) {
    const [visibilityConditionFulfilled, setVisibilityConditionFulfilled] = (0, react_1.useState)(false);
    const visibilityConditionRef = (0, react_1.useRef)(visibilityCondition);
    visibilityConditionRef.current = visibilityCondition;
    (0, react_1.useEffect)(() => {
        const delayTimeMs = visibilityConditionRef.current.delayTimeMs;
        let isMounted = true;
        const timeoutId = setTimeout(() => {
            if (isMounted) {
                setVisibilityConditionFulfilled(true);
            }
        }, delayTimeMs);
        return () => {
            clearTimeout(timeoutId);
            isMounted = false;
        };
        // This effect should only run on mount.
        // Hence the dependency array should be stable variables only that dont change
    }, []);
    return visibilityConditionFulfilled;
}
exports.useDelayedConditionEvaluator = useDelayedConditionEvaluator;
//# sourceMappingURL=useDelayedConditionEvaluator.js.map